import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from '@stockx/ui';
import { YearSelectProps } from './YearSelectProps';

const YearSelect: React.FC<YearSelectProps> = ({ setValue }) => {
  const { t } = useTranslation();

  const selectOptions = useMemo(() => {
    const now = new Date().getUTCFullYear();
    const years = Array(now - 1984)
      .fill('')
      .map((_, idx) => ({
        value: now - idx,
        text: now - idx,
      }));

    return [
      {
        value: '',
        text: t('Year'),
      },
      ...years,
    ];
  }, []); // eslint-disable-line  react-hooks/exhaustive-deps

  return (
    <Select
      data-testid="condition-select-list"
      onChange={(e) => setValue(e.target.value)}
    >
      {selectOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.text}
        </option>
      ))}
    </Select>
  );
};

export default YearSelect;
